import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import Image from 'next/image';

const { Title } = Typography;

const VMCWhichOne = () => {
  return (
    <Row gutter={[12, 24]} justify="center">
      <Col span={24} style={{ textAlign: 'center' }}>
        <h2>Which Email Would You Trust More?</h2>
      </Col>
      <Col span={24}>
        <Row justify="center" style={{ gap: '4rem' }}>
          <Col style={{ textAlign: 'center' }}>
            <Title level={4} className="text-100 bold color-red-400 text-uppercase">
              Without VMC <CloseOutlined style={{ color: 'red' }} />
            </Title>
            <Image
              src="/images/bofa-not-verified.svg"
              alt="Without VMC"
              height={259 * 2}
              width={248 * 2}
              style={{ height: 'auto' }}
            />
          </Col>
          <Col style={{ textAlign: 'center' }}>
            <Title level={4} className="text-100 bold color-accent-1 text-uppercase">
              With VMC <CheckOutlined style={{ color: 'green' }} />
            </Title>
            <Image
              src="/images/bofa-verified.svg"
              alt="With VMC"
              height={259 * 2}
              width={248 * 2}
              style={{ height: 'auto' }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default VMCWhichOne;
